module.exports = __webpack_public_path__ + "img/shop6.052115cd.png";